import { render, staticRenderFns } from "./modifyConfig.vue?vue&type=template&id=616e9d47&scoped=true"
import script from "./modifyConfig.vue?vue&type=script&lang=js"
export * from "./modifyConfig.vue?vue&type=script&lang=js"
import style0 from "./modifyConfig.vue?vue&type=style&index=0&id=616e9d47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e9d47",
  null
  
)

export default component.exports